"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var distill;
(function (distill) {
    var dashboards;
    (function (dashboards) {
        var publicView;
        (function (publicView) {
            let _args;
            let _currentAccessToken = null;
            let _lastTokenRefreshTime = 0;
            let _tokenExpiryWindowMs = 2.5 * 60 * 1000;
            function getAccessToken() {
                return _currentAccessToken;
            }
            publicView.getAccessToken = getAccessToken;
            function run(args) {
                _args = args;
                if (args.exportUrl)
                    distill.dashboards.exportUrl = args.exportUrl;
                distill.dashboards.isPublicView = true;
                const titleBar = args.design.components.find(c => c.type === distill.dashboards.ComponentType.titleBar);
                const refreshInterval = (titleBar === null || titleBar === void 0 ? void 0 : titleBar.refreshInterval) || '5m';
                const refreshMs = distill.dashboards.getIntervalMs(refreshInterval);
                distill.dashboards.designer = new distill.dashboards.DashboardDesigner(args.datasets);
                appn.designerv2.canvas = new distill.dashboards.GridStackCanvas({
                    column: 12,
                    staticGrid: true,
                    float: true,
                    disableResize: true,
                    disableDrag: true,
                    itemClass: 'component',
                    cellHeight: 'initial'
                });
                distill.dashboards.designer.setDesign(args.design);
                appn.designerv2.canvas.render(args.design);
                let lastWindowWidth = window.innerWidth;
                window.addEventListener('resize', () => {
                    if (window.innerWidth === lastWindowWidth)
                        return;
                    lastWindowWidth = window.innerWidth;
                    const canvas = appn.designerv2.canvas;
                    if (canvas && canvas._grid && canvas._grid.el) {
                        const gridWidth = canvas._grid.el.clientWidth;
                        const newCellHeight = Math.floor(gridWidth / 12);
                        if (newCellHeight > 0)
                            canvas._grid.cellHeight(newCellHeight);
                    }
                });
                setTimeout(() => {
                    window.dispatchEvent(new Event('resize'));
                }, 150);
                distill.dataCache.init(refreshMs * 4);
                distill.dashboards.dataManager.init(args.dataFetchUrl, () => __awaiter(this, void 0, void 0, function* () {
                    yield ensureValidAccessToken();
                    return _currentAccessToken;
                }));
                setupRendering();
                setupDataFetching();
                setupGlobalFilterPane(args);
                setInterval(() => {
                    distill.eventBus.publish(distill.EVENTS.DATA_REFRESH_REQUESTED, {});
                }, refreshMs);
                distill.eventBus.publish(distill.EVENTS.DATA_REFRESH_REQUESTED, {});
            }
            publicView.run = run;
            function fetchAccessToken() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        const response = yield fetch(_args.tokenUrl, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' }
                        });
                        const result = yield response.json();
                        if (result.success && result.token) {
                            _currentAccessToken = result.token;
                            _lastTokenRefreshTime = Date.now();
                        }
                        else
                            clearDashboardData();
                    }
                    catch (error) {
                        clearDashboardData();
                    }
                });
            }
            function ensureValidAccessToken() {
                return __awaiter(this, void 0, void 0, function* () {
                    const now = Date.now();
                    const timeSinceRefresh = now - _lastTokenRefreshTime;
                    if (_currentAccessToken && timeSinceRefresh < _tokenExpiryWindowMs)
                        return true;
                    if (timeSinceRefresh >= _tokenExpiryWindowMs || !_currentAccessToken) {
                        yield fetchAccessToken();
                        return _currentAccessToken !== null;
                    }
                    return false;
                });
            }
            publicView.ensureValidAccessToken = ensureValidAccessToken;
            function clearDashboardData() {
                distill.dataCache.clear();
                _currentAccessToken = null;
                _lastTokenRefreshTime = 0;
            }
            const _filterMap = new Map();
            function setupDataFetching() {
                function fetchData(viewNames, componentId, widgetFilters, pagingWindow) {
                    return __awaiter(this, void 0, void 0, function* () {
                        const body = {
                            accessToken: _currentAccessToken,
                            sortOverrides: distill.dashboards.widgets.collectSortOverrides(),
                            viewNames: viewNames && viewNames.length > 0 ? viewNames : null
                        };
                        if (componentId)
                            body.componentId = componentId;
                        const filters = [...dashboards.globalFilterPane.getAppliedFilters(), ...(widgetFilters || [])];
                        if (filters.length > 0)
                            body.filters = filters;
                        const windows = pagingWindow ? [{ componentId: componentId, offset: pagingWindow.offset, limit: pagingWindow.limit }] : dashboards.dataManager.getTableWindows();
                        if (windows.length > 0)
                            body.windows = windows;
                        return yield fetch(_args.dataFetchUrl, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(body)
                        });
                    });
                }
                distill.eventBus.subscribe(distill.EVENTS.DATA_REFRESH_REQUESTED, (payload) => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b;
                    try {
                        if (!(yield ensureValidAccessToken())) {
                            clearDashboardData();
                            return;
                        }
                        if ((payload === null || payload === void 0 ? void 0 : payload.componentId) && (payload === null || payload === void 0 ? void 0 : payload.filters) !== undefined) {
                            if (payload.filters && payload.filters.length > 0)
                                _filterMap.set(payload.componentId, payload.filters);
                            else
                                _filterMap.delete(payload.componentId);
                        }
                        if (payload === null || payload === void 0 ? void 0 : payload.resetTablePaging)
                            dashboards.dataManager.resetTableWindows();
                        const targetCompId = payload === null || payload === void 0 ? void 0 : payload.componentId;
                        const filtersToSend = targetCompId
                            ? (_filterMap.get(targetCompId) || [])
                            : Array.from(_filterMap.values()).flat();
                        const viewNames = (payload === null || payload === void 0 ? void 0 : payload.viewName) ? [payload.viewName] : null;
                        console.log("fetching data...");
                        let response = yield fetchData(viewNames, targetCompId, filtersToSend, payload === null || payload === void 0 ? void 0 : payload.window);
                        if ([401, 403].includes(response.status)) {
                            yield fetchAccessToken();
                            if (_currentAccessToken)
                                response = yield fetchData(viewNames, targetCompId, filtersToSend, payload === null || payload === void 0 ? void 0 : payload.window);
                        }
                        const result = yield response.json();
                        if (result.Error)
                            throw new Error(`Query result error! Message: ${result.Error}`);
                        distill.eventBus.publish(distill.EVENTS.DATA_FETCH_SUCCESS, result);
                    }
                    catch (error) {
                        console.error("fetching data failed:", error);
                        const httpError = error;
                        if (((_a = httpError.message) === null || _a === void 0 ? void 0 : _a.includes('401')) || ((_b = httpError.message) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes('unauthorized')))
                            clearDashboardData();
                    }
                }));
                function publishQueryResult(componentId, response, success) {
                    distill.eventBus.publish(dashboards.DASH_EVENTS.AI_QUERY_RESULT, {
                        componentId,
                        response,
                        success,
                        upgradeUrl: _args.editUserUrl,
                    });
                }
                function fetchChat(payload) {
                    return __awaiter(this, void 0, void 0, function* () {
                        return yield fetch(_args.aiQueryUrl, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                accessToken: _currentAccessToken,
                                componentId: payload.component.id,
                                question: payload.userQuery,
                                responseMarkdownFormatted: true,
                                history: payload.history || [],
                                historySignature: payload.historySignature
                            })
                        });
                    });
                }
                distill.eventBus.subscribe(dashboards.DASH_EVENTS.AI_QUERY_SEND, (payload) => __awaiter(this, void 0, void 0, function* () {
                    var _c, _d;
                    try {
                        if (!(yield ensureValidAccessToken())) {
                            publishQueryResult(payload.component.id, { Answer: T('Unable to load your chat session. Please refresh the page.'), Charts: [] }, false);
                            return;
                        }
                        let response = yield fetchChat(payload);
                        if ([401, 403].includes(response.status) && _currentAccessToken) {
                            yield fetchAccessToken();
                            if (_currentAccessToken)
                                response = yield fetchChat(payload);
                        }
                        if (!response.ok) {
                            let apiMsg = '';
                            try {
                                apiMsg = ((_d = (_c = (yield response.json())) === null || _c === void 0 ? void 0 : _c.responseStatus) === null || _d === void 0 ? void 0 : _d.message) || '';
                            }
                            catch (_e) { }
                            publishQueryResult(payload.component.id, {
                                Answer: apiMsg === 'Question is required.' ? T('Please ask a question.') : (apiMsg || T('Sorry, something went wrong. Please try again.')),
                                Charts: []
                            }, false);
                            return;
                        }
                        const json = yield response.json();
                        const answer = (json === null || json === void 0 ? void 0 : json.Answer) || T(`To use this widget, you'll need some active artifacts.`);
                        publishQueryResult(payload.component.id, { Answer: answer, Charts: (json === null || json === void 0 ? void 0 : json.Charts) || [], ErrorType: json === null || json === void 0 ? void 0 : json.ErrorType, Turns: json === null || json === void 0 ? void 0 : json.Turns, HistorySignature: json === null || json === void 0 ? void 0 : json.HistorySignature }, true);
                    }
                    catch (error) {
                        publishQueryResult(payload.component.id, { Answer: T('Sorry, something went wrong. Please try again.'), Charts: [] }, false);
                    }
                }));
            }
            function setupGlobalFilterPane(args) {
                dashboards.globalFilterPane.init({
                    design: args.design,
                    fetchGlobalFilterOptions: (filter, search) => __awaiter(this, void 0, void 0, function* () {
                        if (!filter.sourceDatasetId || !filter.displayColumn || !filter.valueColumn)
                            return [];
                        if (!(yield ensureValidAccessToken()))
                            return [];
                        try {
                            const response = yield fetch(args.globalFilterOptionsUrl, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    accessToken: _currentAccessToken,
                                    filterId: filter.id,
                                    search: search || ''
                                })
                            });
                            if (!response.ok)
                                return [];
                            const result = yield response.json();
                            return result && result.Options
                                ? result.Options.map((o) => ({ display: o.Display, value: o.Value, count: o.Count || 0 }))
                                : [];
                        }
                        catch (_a) {
                            return [];
                        }
                    })
                });
            }
            function setupRendering() {
                distill.eventBus.subscribe(distill.EVENTS.DATA_FETCH_SUCCESS, (result) => {
                    const refreshedComponentIds = new Set();
                    result.Views.forEach(datasetResult => {
                        const cacheKey = appn.utils.normalizeIdentifier(datasetResult.Name);
                        const componentId = cacheKey.split('.')[0];
                        if (appn.utils.hasValue(datasetResult.Error))
                            console.error(`Could not fetch data for ${cacheKey}`, datasetResult.Error);
                        if (componentId) {
                            refreshedComponentIds.add(componentId);
                            distill.dataCache.set(cacheKey, datasetResult);
                        }
                    });
                    if (!result || !result.Views)
                        return;
                    refreshedComponentIds.forEach(id => {
                        const component = dashboards.designer.getComponent(id);
                        if (!component)
                            return;
                        const definition = distill.componentManager.getDefinition(component.type);
                        if (!definition || !definition.render)
                            return;
                        const element = $(`#${id}`);
                        if (!element.length)
                            return;
                        definition.render(element, component);
                    });
                });
            }
        })(publicView = dashboards.publicView || (dashboards.publicView = {}));
    })(dashboards = distill.dashboards || (distill.dashboards = {}));
})(distill || (distill = {}));
